<template lang="pug">
  div
    v-row.pa-4(no-gutters align="center")
      v-col.pr-2
        v-text-field(v-model="searchText" :placeholder="$t('search_order')" hide-details dense outlined height="40" background-color="basic200" clearable)
          template(v-slot:append)
            eva-icon(v-if="!searchText" name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600" )
      v-col.pr-2.shrink
        v-menu(bottom left offset-y)
          template(v-slot:activator='{ on }')
            v-btn.elevation-0.pa-0(data-v-step='TourOrderListView-2' color="transparent" small icon v-on='on')
              eva-icon(name="eye-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="23" style="margin-top: 2px")
          v-list.pb-3(width="250")
            template(v-for="item in viewList")
              v-list-item.px-2(@click="clickView(item.name)" :key="item.name")
                v-row(no-gutters)
                  v-col.pr-2.shrink
                    eva-icon(:name="item.icon" :fill="$vuetify.theme.themes[$theme].primary400" height="20" :style="`padding-top: ${item.padtop}`")
                  v-col.pr-2
                    div.s2.basic800--text {{ item.text }}
                    div.c1.basic600--text {{ item.desc }}
              v-divider.basic300.my-1(v-if="item.name !== 'details'")
      v-col.py-2.shrink
        v-btn.elevation-0.pa-0(data-v-step='TourOrderListView-1' color="transparent" small icon @click="openOrderFilter = true")
          eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="23" style="margin-top: 2px")
      //- v-col.py-1.shrink(v-if="woocommerce_enabled || shopify_enabled")
    .modal
      order-details-filter(v-if="openOrderDetailsFilter" :open.sync="openOrderDetailsFilter")
      order-filter(v-if="openOrderFilter" :open.sync="openOrderFilter" :company="company" :orderType="'processing'")
</template>

<script>
import { mapGetters } from 'vuex'
import OrderListView from '@/components/ordermgmt/OrderListView.vue'
import OrderDetailsFilter from '@/components/dialogs/order/OrderDetailsFilter.vue'
import OrderFilter from '@/components/dialogs/order/OrderFilter.vue'

export default {
  name: 'OrderProcessingTop',
  components: { OrderListView, OrderDetailsFilter, OrderFilter },
  props: ['company'],
  data: (vm) => ({
    openOrderDetailsFilter: false,
    openOrderFilter: false,
    searchText: '',
    viewList: [
      { name: 'list', text: vm.$t('list_view'), icon: 'list-outline', desc: vm.$t('list_view_desc'), padtop: '3px' },
      { name: 'calendar', text: vm.$t('calendar_view'), icon: 'calendar-outline', desc: vm.$t('calendar_view_desc'), padtop: '4px' },
      { name: 'kanban', text: vm.$t('kanban_view'), icon: 'layout-outline', desc: vm.$t('kanban_view_desc'), padtop: '4px' },
      { name: 'details', text: vm.$t('add_order_details'), icon: 'plus-square-outline', desc: vm.$t('add_order_details_desc'), padtop: '4px' },
    ]
  }),
  computed: {
    ...mapGetters({
      view: 'orders/getOrderView'
    })
  },
  watch: {
    searchText (val) {
      this.$store.commit('orders/setSearch', val)
    }
  },
  mounted () {
  },
  methods: {
    clickView (e) {
      if (e === 'details') {
        this.openOrderDetailsFilter = true
      } else if (e === 'list') {
        this.$store.commit('orders/setOrderView', 'list')
      } else if (e === 'calendar') {
        this.$store.commit('orders/setOrderView', 'calendar')
      } else if (e === 'kanban') {
        this.$store.commit('orders/setOrderView', 'kanban')
      }
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "calendar_view": "Calendar view",
    "calendar_view_desc":"Month view, for order fulfilment by dates",
    "kanban_view": "Status view",
    "kanban_view_desc":"Kanban board, for keeping track of Processing and Ready orders",
    "add_order_details":"Add order details",
    "add_order_details_desc":"View more details on the order list"
  
  },
  "id": {
    "calendar_view": "Tampilan Kalender",
    "calendar_view_desc":"Tampilan untuk melihat pemesanan kamu berdasarkan tanggal" ,
    "kanban_view": "Tampilan Status",
    "kanban_view_desc":"Tampilan kanban board untuk melacak pemrosesan dan pesanan yang siap",
    "add_order_details":"Tambahkan detail pesanan",
    "add_order_details_desc":"Lihat detail lebih lanjut pada daftar pesanan"
  }
}
</i18n>